import { useTranslation } from 'react-i18next';
import { QrCodeDialog } from '@/components/ui/qr-code-dialog';
import { env } from '@/config/env';
import type { BookingEvent, EventTimeSlot } from './types';

/** The check-in QR code for one time slot. */

export function checkinUrl(timeSlot: EventTimeSlot | null) {
  return timeSlot
    ? `${env.bookingWebfrontUrl}/checkin/timeslot/${timeSlot.id}`
    : '';
}

export function TimeSlotQrDialog({
  event,
  timeSlot,
  open,
  onOpenChange,
}: {
  event: BookingEvent | null;
  timeSlot: EventTimeSlot | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const { t } = useTranslation();

  if (!timeSlot) return null;

  return (
    <QrCodeDialog
      title={t('events.qrCode')}
      caption={event?.name ?? ''}
      url={checkinUrl(timeSlot)}
      fileBase={`timeslot-${timeSlot.id}-qr`}
      open={open}
      onOpenChange={onOpenChange}
    />
  );
}
